import { VUE_APP_BASEURL } from "../../utils/api";
import axios from "axios";
import store from "../../store";
const state = {
    products: [],
    highlightProducts: [],
}
const getters = {
    productList: state => state.products,
    highlightProductList: state => state.highlightProducts,
}

const actions = {

    async getProduct({ commit }, categoryData) {
        //console.log(categoryData.subCategoryId);
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "product/" + store.getters.UserLocation + "?category=" + categoryData.categoryId + "&subcategory=" + categoryData.subCategoryId + "&orderkey=" + store.getters.getCartToken + "&search=" + categoryData.search,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                // console.log(response);
                if (response.data.status == 1) {
                    commit("listProduct", response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    async getHighlighProduct({ commit }) {
        //console.log(categoryData.subCategoryId);
        //console.log(store.getters.getCartToken);
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "highlightedproduct/" + store.getters.UserLocation + "?orderkey=" + store.getters.getCartToken,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                console.log(response);
                if (response.data.status == 1) {
                    commit("highlightProduct", response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
}
const mutations = {
    listProduct: (state, resp) => {
        state.products = resp.response.product;
    },
    highlightProduct: (state, resp) => {
        state.highlightProducts = resp.response.product;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
};